var _rect, _path, _rect2, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconexl = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EBF6EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 6H10C8.897 6 8 6.898 8 8V24C8 25.103 8.897 26 10 26H22C23.103 26 24 25.103 24 24V10.586L19.414 6ZM11 16H19V18H11V16ZM21 22H11V20H21V22ZM18 12V7L23 12H18Z",
    fill: "#008908"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 12,
    height: 8,
    fill: "#008908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5797 22V18.3636H14.03V18.9975H12.3485V19.864H13.9039V20.4979H12.3485V21.3661H14.0371V22H11.5797ZM15.3621 18.3636L16.0954 19.603H16.1238L16.8607 18.3636H17.729L16.6192 20.1818L17.7538 22H16.8696L16.1238 20.7589H16.0954L15.3497 22H14.469L15.6072 20.1818L14.4903 18.3636H15.3621ZM18.2155 22V18.3636H18.9843V21.3661H20.5432V22H18.2155Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconexl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconexl.eec8e71a.svg";
export { ForwardRef as ReactComponent };